import {
    FETCH_ACTIVITY_SUMMARY_MONTHLY,
    FETCH_ACTIVITY_SUMMARY_MONTHLY_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED_SUCCESS
} from '../../actions/ActionTypes.js';

const fetchActivitySummaryMonthlySuccess = (state, action) => {
    return {
        ...state,
        byAll: action.activitySummaryMonthly
    };
};

const fetchActivitySummaryMonthlyGroupedSuccess = (state, action) => {
    return {
        ...state,
        byActivity: action.activitySummaryMonthly
    };
};

const handlers = {
    [FETCH_ACTIVITY_SUMMARY_MONTHLY_SUCCESS]: fetchActivitySummaryMonthlySuccess,
    [FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED_SUCCESS]: fetchActivitySummaryMonthlyGroupedSuccess
};

const initialState = {
    byAll: null,
    byActivity: null
};

export default function activityTypes(state = initialState, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchActivitySummaryMonthly(displayName, fromDate, toDate, groupByActivity) {
    return {
        type: FETCH_ACTIVITY_SUMMARY_MONTHLY,
        payload: {
            displayName,
            fromDate,
            toDate,
            groupByActivity
        }
    };
}
